import { Button } from "@/modern/components/ui/button-shadcn";
import { NotebookPen, Plus } from "lucide-react";
import { useEntityNotesContext } from "../context/EntityNotesContext";

export const EmptyNotesState = () => {
  const { handleOpenEditor } = useEntityNotesContext();
  return (
    <div className="h-full flex flex-col items-center justify-center gap-6 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 px-8 py-8 text-center shadow-sm m-4">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <NotebookPen className="size-6" />
      </div>
      <div className="space-y-2">
        <h3 className="text-base font-semibold text-foreground">Rich-Text Notes</h3>
        <p className="text-sm text-muted-foreground min-h-[2.5rem] flex items-center">Add detailed, formatted notes for the team.</p>
      </div>
      <Button className="inline-flex items-center gap-2" onClick={() => handleOpenEditor(undefined, true)}>
        <Plus className="size-4" />
        New note
      </Button>
    </div>)
};
